import {post_data} from './API_Calls.js';
import * as RO from './ReportObjects';

export let page_size = [[1200, 800], [800, 1200]];
export let is_portrait = false;

function warnIfWebGLMissing() {
	if (typeof window === "undefined" || typeof document === "undefined") return;

	const canvas = document.createElement("canvas");
	const hasWebGL = !!window.WebGLRenderingContext && !!canvas.getContext("webgl");
	const hasWebGL2 = !!window.WebGL2RenderingContext && !!canvas.getContext("webgl2");

	if (!hasWebGL) {
		console.warn("WebGL is not supported in this browser. Map rendering may fail.");
	}
	if (!hasWebGL2) {
		console.warn("WebGL2 is not supported in this browser. Some map features may fail.");
	}
}

warnIfWebGLMissing();

export function toggle_download_button(callback) {
    var download_btn = document.getElementById("download_pdf_btn");

    if (!download_btn) {
        console.error("Button not found!");
        return;
    }

    download_btn.disabled = false;
    download_btn.addEventListener('click', () => callback);
}

function convertToDdm(lat: number, lon: number) {
    const latDeg = Math.trunc(Math.abs(lat));
    const latMin = (Math.abs(lat) - latDeg) * 60;
    const latDir = lat >= 0 ? 'N' : 'S';

    const lonDeg = Math.trunc(Math.abs(lon));
    const lonMin = (Math.abs(lon) - lonDeg) * 60;
    const lonDir = lon >= 0 ? 'E' : 'W';

    return {
        LatDeg: latDeg,
        LatMin: latMin,
        LatDir: latDir,
        LatString: `${latDeg}° ${latMin.toFixed(3)}' ${latDir}`,
        LonDeg: lonDeg,
        LonMin: lonMin,
        LonDir: lonDir,
        LonString: `${lonDeg}° ${lonMin.toFixed(3)}' ${lonDir}`,
    };
}

function convertToDms(lat: number, lon: number) {
  const latDeg = Math.trunc(Math.abs(lat));
  const latMinFull = (Math.abs(lat) - latDeg) * 60;
  const latMin = Math.trunc(latMinFull);
  const latSec = (latMinFull - latMin) * 60;
  const latDir = lat >= 0 ? 'N' : 'S';

  const lonDeg = Math.trunc(Math.abs(lon));
  const lonMinFull = (Math.abs(lon) - lonDeg) * 60;
  const lonMin = Math.trunc(lonMinFull);
  const lonSec = (lonMinFull - lonMin) * 60;
  const lonDir = lon >= 0 ? 'E' : 'W';

  return {
    LatDeg: latDeg,
    LatMin: latMin,
    LatSec: latSec,
    LatDir: latDir,
    LatString: `${latDeg}° ${latMin}' ${latSec.toFixed(2)}" ${latDir}`,
    LonDeg: lonDeg,
    LonMin: lonMin,
    LonSec: lonSec,
    LonDir: lonDir,
    LonString: `${lonDeg}° ${lonMin}' ${lonSec.toFixed(2)}" ${lonDir}`,
  };
}

export function populateLocation(location: Location): Location {
    const DEC = location.dec;
    return {
        dec: DEC,
        Ddm: convertToDdm(DEC.lat, DEC.lon),
        Dms: convertToDms(DEC.lat, DEC.lon),
    };
}

export async function getReportParameters(reportId){
    var param = {
        "report_uuid" : reportId
    };

    return await post_data("/get_ReportParameters", param) || null;
}

export async function getUserDetails(parent_uuids, user_uuids, user_emails){
    var param = {
        "parent_account_uuids" : parent_uuids ? [parent_uuids] : [],
        "user_account_uuids": user_uuids ? [user_uuids] : [],
        "user_emails": user_emails ? [user_emails] : []
    };

    return await post_data("/get_MariTraceUserAccount", param) || null;
}

export let currentUserDetails = RO.user_details;
export let currentParentDetails = RO.user_parent;

export function getSessionUser() {
  return currentUserDetails;
}

export function setSessionUser(details) {
    currentUserDetails = details;
    if(currentUserDetails.maritrace_parent_account) setSessionParent(currentUserDetails.maritrace_parent_account)
}
export function getSessionParent() {
  return currentParentDetails;
}

export function setSessionParent(details) {
  currentParentDetails = details;
}
export function getPagePortrait() {
  return is_portrait;
}

export function setPagePortrait(portrait) {
  is_portrait = portrait;
}

export function displayValue(value){
    return value !== null && value !== undefined && value !== '' ? value : 'UNKNOWN';
}

export function filterPositions(current_pos, next_pos, prev_pos, granularity){
    var distance_travelled = haversine(current_pos.latitude, current_pos.longitude, next_pos.latitude, next_pos.longitude);
    var date_difference = Math.abs(current_pos.date_received.getTime() - next_pos.date_received.getTime());
    var time_difference = date_difference / (1000 * 60 * 60 * 24);

    if(granularity == "h") time_difference = date_difference / (1000 * 60 * 60);

    if((granularity == "h" && ((time_difference * 150) < distance_travelled)) ||
    (granularity == "d" && ((time_difference * 1700) < distance_travelled))){
        var distance_travelled2 = haversine(prev_pos.latitude, prev_pos.longitude, current_pos.latitude, current_pos.longitude);
        var prev_date_difference = next_pos.date_received.getTime() - current_pos.date_received.getTime();
        var prev_time_difference = date_difference / (1000 * 60 * 60 * 24);

        if(granularity == "h") prev_time_difference = date_difference / (1000 * 60 * 60);
        if((granularity == "h" && ((prev_time_difference * 150) < distance_travelled2)) ||
        (granularity == "d" && ((prev_time_difference * 1700) < distance_travelled2))){
            //console.log("current_pos: ", current_pos);
            //console.log("next_pos: ", next_pos);
            return true;
        }
    }
    return false;
}

export function haversine(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const toRad = deg => deg * Math.PI / 180;

    const lat1Rad = toRad(lat1);
    const lat2Rad = toRad(lat2);
    const deltaLat = toRad(lat2 - lat1);
    const deltaLon = toRad(lon2 - lon1);

    const a = Math.sin(deltaLat / 2) ** 2 +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
            Math.sin(deltaLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

export function totalDistance(positions) {
  let total = 0;

  for (let i = 1; i < positions.length; i++) {
    total += haversine(positions[i - 1].longitude, positions[i - 1].latitude, positions[i].longitude, positions[i].latitude);
  }

  return Math.round(total);
}

export function checkMapLayers(map) {
    /*map.moveLayer('MTPathLine-1');
    map.getStyle().layers.forEach(layer => {
        if (layer.id.includes("MTPathLine")){
            const src = map.getSource(layer.source);
            const feats = src?._data?.features;
            let featCount = feats?.length || 0;
            let pointCount = feats ? feats.reduce((sum, f) => sum + f.geometry.coordinates.flat(2).length, 0) : 0;
            console.log(`ID: ${layer.id}, Type: ${layer.type}, Source: ${layer.source}, Features: ${featCount}, Points: ${pointCount}`);
        }
    });

    map.setLayoutProperty('MTPathLine-0', 'visibility', 'none');
    map.setLayoutProperty('MTPathLine-2', 'visibility', 'none');
    map.setLayoutProperty('MTPathLine-1', 'visibility', 'visible');*/
}
